// extracted by mini-css-extract-plugin
export default {"container":"style_container__Nwt70","page":"style_page__2MZ8V","page_3d":"style_page_3d__tUVOa"};